import ToastComponent from '../../fabric/toaster.vue'
import { AVAILABLE_COLOURS } from './constants'
import Vue from 'vue'

export const props = {
  position: {
    type: String,
    default: 'top-left'
  },
  title: {
    type: [String],
    default: ''
  },
  content: {
    type: [String, Object],
    default: ''
  },
  name: {
    type: String,
    default: 'toaster'
  },
  timer: {
    type: [Number, Boolean],
    default: false
  },
  variant: {
    type: [String, Boolean],
    default: false
  },
  colour: {
    type: [String],
    validator: function (value) {
      // The value must match one of these strings
      return AVAILABLE_COLOURS.includes(value)
    },
    required: true,
  },
}

export const Toaster = /* #__PURE__ */ Vue.extend({
  name: 'BaseToast',
  mixins: [],
  props,
  data() {
    return {
      isHidden: false
    }
  },
  beforeMount() {
    // todo animation
  },
  beforeDestroy() {
    // todo animation
  },
  destroyed() {
    // todo animation
  },
  mounted() {
    const self = this
    if(this.timer) {
      setTimeout(() => {
        self.onClose()
      }, this.timer)
    }
    this.$root.$on('event-static-show', data => {
      this.onClose()
    })
  },
  methods: {
    onClose() {
      this.isHidden = true
    },
  },
  render(h) {
    const { position, title, content, isHidden, variant } = this
    const $toaster = h(ToastComponent, {
      staticClass: 'toaster-item',
      props: {
        position,
        content,
        title,
        isHidden,
        variant,
        colour: this.colour,
        onClose: this.onClose,
        isStatic: true,
      },
    })
    return $toaster
  }
})
